import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, change } from 'redux-form';
import _ from 'lodash';
import {
	Row,
	Col,
	Button,
	FormGroup,
	FormControl,
	InputGroup
} from 'react-bootstrap';
import  {
	blue,
	orange,
	eventstatus,
  StatusKey,
    forms
} from '../../../utils/constants'
import { fetchingEvents, fetchEvents } from '../../../redux/actions/action_event';
import { getActiveSeasons } from '../../../components/common/api'

export const SearchBy = {
	EventName: 'name',
	Director: 'email',
	DirectorName: "dirname",
	Status: 'status',
	Date: 'date',
  Membership: 'membership',
  EventEmail: 'eventEmail'
}
export const SearchType = {
	Event:'Event',
	Director:'Director'
}
const SearchByDescription = {
	EventName: "Event's name",
	Director: "Director's email",
	DirectorName: "Director's name",
	Status: 'Status',
	Date: 'Date',
  Membership: "Director's member Id",
  EventEmail: "Event's Email"
}

const formName = forms.eventinfo

class SearchBar extends Component { 
  constructor(props)
  {
    super(props)   
		this.state = { 
			seasons:[],
			seasonId:'',
			searchBy: this.props.SearchByDefault ? this.props.SearchByDefault : SearchBy.Status ,
			searchValue:'',
			searchMode:false,
			statusSearchValue:'all',
			freeTextSearch:  this.props.SearchByDefault ? (this.props.SearchByDefault === SearchBy.Status ? false: true) : false
		}
		this.handleAddEvent = this.handleAddEvent.bind(this)
		this.handleSearch   = this.handleSearch.bind(this)
		this.handleSearchByChange = this.handleSearchByChange.bind(this)
		this.handleSearchByStatusChange = this.handleSearchByStatusChange.bind(this)
		this.handleSearchValueChange = this.handleSearchValueChange.bind(this)
		this.setSelectValues = this.setSelectValues.bind(this)
		this.setSearchTextField = this.setSearchTextField.bind(this)
		this.setSearchDateField = this.setSearchDateField.bind(this)
		this.setModes = this.setModes.bind(this)
		this.setSearchByOptions = this.setSearchByOptions.bind(this)
		this.handleValueChange = this.handleValueChange.bind(this)	
		this.setSeasons = this.setSeasons.bind(this)	
		this.handleSearchSeasonChange = this.handleSearchSeasonChange.bind(this)
	}

	componentDidMount()	{
		const _this = this;
		const { dispatch } = this.props;
		getActiveSeasons().then(function(response) {
			_this.setState({ seasons:response.data, seasonId: response.data[0].id });
			dispatch(change(formName,'seasonId',response.data[0].id));
		})
	}
	componentWillReceiveProps(nextProps) {
		const { refreshSearch } = nextProps;
		
		if(refreshSearch === true) {
			this.handleSearch();
		}
	}
	handleValueChange(evt) {
		const searchValue = evt.target.value;
		this.setState({ searchValue: searchValue });
	}
	handleSearch( ) {
        const { searchBy, searchValue, statusSearchValue, seasonId } = this.state;
        const { dispatch, onSearch } = this.props;
		let searchCriteria = searchValue;

		if(searchBy === SearchBy.Status) {
			searchCriteria = statusSearchValue;
		}

		dispatch(fetchingEvents());
		dispatch(fetchEvents(seasonId, searchBy, searchCriteria, searchValue));
		onSearch();
    }

	handleSearchByChange = (event) => {
		const searchby = event.target.value;
		let freetextsearch = true;

		if((searchby == SearchBy.Status))
		{
			freetextsearch  = false;
		}
		this.setModes(false,freetextsearch,searchby,'');
		this.props.SearchByChange();
	}
	handleSearchByStatusChange(event){
		const searchvalue = event.target.value;
		this.setState({ statusSearchValue:searchvalue });
  }

	handleSearchValueChange = () => {
		this.setState({
				addNewEventMode: false
		})
	}

	handleAddEvent() {
		this.props.handleAddEvent();
	}
	
	isFreeText = () => { 
		const { searchBy, freeTextSearch } = this.state
		return searchBy != SearchBy.All && searchBy != SearchBy.Date && freeTextSearch
	}

	isSelect = () => { 
		return this.state.searchBy == SearchBy.Status
	}

	isDateField = () => {
		return this.state.searchBy == SearchBy.Date
	}

	setSelectValues = () => {
		const attrs = {
			name:'searchvalue',
			componentClass:'select',
			onChange: this.handleSearchValueChange ,
			style:{ minWidth:"280px" }
		}
		switch(this.state.searchBy)
		{
			case SearchBy.Status:
			{
				const notcomplete =  _.find(eventstatus, { key:StatusKey.SetupNotCompleted })
				const pendingapproval =  _.find(eventstatus, { key:StatusKey.PendingApproval })
				const upcoming =  _.find(eventstatus, { key:StatusKey.UpcomingEvent })
				const pendingpost =  _.find(eventstatus, { key:StatusKey.PendingPost })
        const completed = _.find(eventstatus, { key: StatusKey.Completed })
        const canceled = _.find(eventstatus, { key: StatusKey.Canceled })

        
				return(
					<FormControl {...attrs} defaultValue="all" onChange={this.handleSearchByStatusChange} style={{ minWidth:'250px',borderRadius:'0', height:'36px' }}>
						<option value="all">All</option> 
						<option value={notcomplete.description}>{ notcomplete.description }</option>  
						<option value={pendingapproval.description}>{ pendingapproval.description }</option>  
						<option value={upcoming.description}>{ upcoming.description }</option>           
						<option value={pendingpost.description}>{ pendingpost.description }</option>   
            <option value={completed.description}>{completed.description}</option>
						<option value={canceled.description}>{ canceled.description }</option>               
          </FormControl>
				)
			}
		}    
  }
	
	setSearchTextField = () => {
		const fldtype = 'text'
		return (<FormControl type={fldtype} placeholder={this.state.searchBy === SearchBy.Membership ? 'xxxxx-xxxxxxx' : 'Enter value'} style={{ minWidth:'270px' }} value={this.state.searchValue} onChange={this.handleValueChange}/>)
  }

  setSearchDateField = () => {
		const fldtype = 'date'
		return (<FormControl type={fldtype} style={{ minWidth:'150px' }} className='unstyled' onChange={this.handleValueChange} />)
	}
	
	setModes = (neweventmode, freetextsearch=null,searchby=null,searchValue='') => {
		this.setState({
			addNewEventMode: neweventmode,
			freeTextSearch: freetextsearch !== null ? freetextsearch : this.state.freeTextSearch,
			searchBy: searchby !== null ? searchby : this.state.searchBy,
			searchValue,
			statusSearchValue:'all'
		})
	}
	setSearchByOptions = () => {
		
		const { SearchByOptions, ControlSearchType, isAdministrator } = this.props

		if(ControlSearchType && ControlSearchType === SearchType.Director)
		{
			return ([
				(SearchByOptions ?	SearchByOptions.includes(SearchBy.DirectorName) : true) && <option hidden={!isAdministrator} value={SearchBy.DirectorName} key='1'>{ SearchByDescription.DirectorName }</option>,
				(SearchByOptions ?	SearchByOptions.includes(SearchBy.Director) : true)  && <option hidden={!isAdministrator} value={SearchBy.Director} key='6'>{ SearchByDescription.Director }</option>,
				(SearchByOptions ?	SearchByOptions.includes(SearchBy.Membership) : true)  && <option hidden={!isAdministrator} value={SearchBy.Membership} key='2'>{ SearchByDescription.Membership }</option>
			])
		}
		return ([
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.Status) : true)  && <option value={SearchBy.Status} key='3'>{ SearchByDescription.Status }</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.DirectorName) : true) && <option hidden={!isAdministrator} value={SearchBy.DirectorName} key='1'>{ SearchByDescription.DirectorName }</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.EventName) : true)  && <option value={SearchBy.EventName} key='2'>{ SearchByDescription.EventName }</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.Membership) : true)  && <option hidden={!isAdministrator} value={SearchBy.Membership} key='4'>{ SearchByDescription.Membership }</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.Date) : true)  && <option value={SearchBy.Date} key='5'>{ SearchByDescription.Date }</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.Director) : true)  && <option hidden={!isAdministrator} value={SearchBy.Director} key='6'>{ SearchByDescription.Director }</option>,
      (SearchByOptions ? SearchByOptions.includes(SearchBy.EventEmail) : true) && <option hidden={!isAdministrator} value={SearchBy.EventEmail} key='7'>{SearchByDescription.EventEmail}</option>
    ])
	}

	setSeasons()
	{	
		const { seasons } = this.state;
		const seasonsArray = Object.values(seasons)
		const option = seasonsArray.map((season) => {
		return (<option key={season.id} value={season.id}>{season.description}</option>)
		})
		return option
	}

	handleSearchSeasonChange = (event) => {
		const season = event.target.value
		const { dispatch } = this.props;		
		this.setState({
			seasonId:season
		})
		dispatch(change(formName,'seasonId',season));
	}

	render()
	{
		const { 
			isEventSetup,
			SearchByDefault
		} = this.props;

		const { 
			searchMode,
			searchBy,
			addNewEventMode,
			searchValue, 
			seasons,
		} = this.state;

		const activeSeasons = (_.find(seasons,{ isSeasonSet: true }) !== undefined);

		return (<Row>
			<Col sm={12}>
				<div className="stacked-filter-panel">
					<FormGroup controlId="searchby" className="searchby-filter">
					<FormControl  componentClass="select" onChange = { this.handleSearchSeasonChange } style={{ minWidth:'120px',borderRadius:'0' }}>
						{
							this.setSeasons() 
						}
					</FormControl>
					<FormControl  defaultValue={SearchByDefault ? SearchByDefault:SearchBy.Status} componentClass="select" placeholder="All" onChange = { this.handleSearchByChange } style={{ minWidth:'180px',borderRadius:'0' }}>
						{
							this.setSearchByOptions()
						}
					</FormControl>
					<InputGroup>			
						{ 
							this.isFreeText() && 
							this.setSearchTextField()
						}
						{
							this.isSelect() &&
							this.setSelectValues()
						}
						{
							this.isDateField() &&
							this.setSearchDateField()
						}
					
						<InputGroup.Button>
							<Button onClick={ this.handleSearch } style={{ color:orange, marginLeft:'-2px', minHeight:'36px' }} disabled={ searchValue.length < 3 && searchBy != SearchBy.Status || !activeSeasons }>
								<i className={ searchMode === true ? "fa fa-spinner fa-spin":"fa fa-search"} aria-hidden="true"  />
							</Button>
						</InputGroup.Button> 
						{
							isEventSetup && (<InputGroup.Button>
							<Button style={{ color:blue, minHeight:'36px' }} onClick={ this.handleAddEvent } disabled={ addNewEventMode || !activeSeasons}>
								<i className="fa fa-calendar" aria-hidden="true"  />&nbsp;&nbsp; Add Event
							</Button>
							</InputGroup.Button>)
						}
						</InputGroup>
					</FormGroup>
				</div>
			</Col>
	</Row>)
	}
}
SearchBar.propTypes = {
	isAdministrator: PropTypes.bool,
	isEventSetup: PropTypes.bool,
	SearchByDefault: PropTypes.string,
	SearchByOptions:PropTypes.array,
	ControlSearchType: PropTypes.string,
	handleSearchResults:PropTypes.func,
	handleAddEvent:PropTypes.func,
	token: PropTypes.string,
	executeSearchByStatus: PropTypes.string,
	refreshSearch: PropTypes.bool,
    SearchByChange: PropTypes.func,
	dispatch: PropTypes.func,
	onSearch: PropTypes.func
}

function mapStateToProps(state,ownProps){
	const formName          =  ownProps.form;
	const selector          = formValueSelector(formName);
	const searchMode		= selector(state, 'searchMode');
	return {
		searchMode
	};
  }
  function mapDispatchToProps(dispatch){
	return bindActionCreators({
		fetchingEvents,
		fetchEvents
		},dispatch)
  }
  export default reduxForm({
	form:formName,
	destroyOnUnmount: false
  })(connect(mapStateToProps,mapDispatchToProps)(SearchBar))


// WEBPACK FOOTER //
// ./src/containers/event/components/searchbar.js